<div *ngIf="isHidden" class="d-flex align-items-center automation-warning p-10 mt-10 mb-10">
  <i class="icon-ico_eye_off automated-icon top-message me-2"></i>
  This page was hidden from end-users.
</div>
<ey-mail-summary [mailSections]="mailSections" class="d-block pb-20"></ey-mail-summary>
<ey-froala-content-wrapper class="d-block mb-20" *ngFor="let block of htmlBlocks" [editorContent]="block.content"> </ey-froala-content-wrapper>
